import styled from 'styled-components';
import { MainMenu, MainMenuItem } from '@make-software/cspr-design';
import { STAMPS_PATH, HOME_PATH, INBOX_PATH, OUTBOX_PATH } from '@/paths';

import { Link } from '../link';
import { useContext } from 'react';
import { ConnectedAccountContext } from '@/contexts/ConnectedAccountContext';

const MainMenuWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    position: 'relative',
    padding: 0,
    paddingBottom: [19, 19, 0],
    width: ['100%', '100%', 'auto'],
    '& li': {
      ':last-child': {
        paddingRight: 0,
      },
    },
  })
);

const MenuItems = () => {
  const connectedAccount = useContext(ConnectedAccountContext);
  if (!connectedAccount) {
    return <></>;
  }

  return (
    <MainMenuWrapper>
      <MainMenu>
        <MainMenuItem>
          <Link to={HOME_PATH}>Home</Link>
        </MainMenuItem>
        <MainMenuItem>
          <Link to={STAMPS_PATH}>Stamps</Link>
        </MainMenuItem>
        <MainMenuItem>
          <Link to={OUTBOX_PATH}>Outbox</Link>
        </MainMenuItem>
        <MainMenuItem>
          <Link to={INBOX_PATH}>Inbox</Link>
        </MainMenuItem>
      </MainMenu>
    </MainMenuWrapper>
  );
};

export default MenuItems;
